var InFlight = InFlight || {};
(function() {
  function _isLoggedInResultPage() {
    return window.ifReferenceWindow.location.search.indexOf('login=true') >= 0;
  }

  InFlight.User = (function() {
    var _states = {
      ENTITY_TYPE_BIDDER: 'Bidder',
      ENTITY_TYPE_SUPPLIER: 'Supplier',
      ACCOUNT_TYPE_BIDDER: 'Bidder',
      ACCOUNT_TYPE_SUBCONTRACTOR: 'Subcontractor',
      ACCOUNT_TYPE_SUPPLIER_ISSUES: 'Supplier Issues',
      ACCOUNT_TYPE_APPROVED_SUPPLIER: 'Approved Supplier',
      SUPPLIER_STATE_NONE: '',
      SUPPLIER_STATE_UNAPPROVED: 'Unapproved',
      SUPPLIER_STATE_APPROVED: 'Approved',
      GOV_CLASS_NONE: '',
      GOV_CLASS_TAX: 'TAX',
      GOV_CLASS_EX: 'EX',
      GOV_CLASS_DND: 'DND',
      GOV_CLASS_DLQ: 'DLQ',
      SUPPLIER_EXPIRATION_STATUS_INCOMPLETE: 'Incomplete',
      SUPPLIER_EXPIRATION_STATUS_GOOD: 'Good',
      SUPPLIER_EXPIRATION_STATUS_IMMINENT: 'Imminent',
      SUPPLIER_EXPIRATION_STATUS_EXPIRED: 'Expired',
      COMPLIANCE_STATUS_NONE: '',
      COMPLIANCE_STATUS_PENDING: 'Pending',
      COMPLIANCE_STATUS_DENIED: 'Denied',
      COMPLIANCE_STATUS_CONTRACT: 'Contract by Contract',
      COMPLIANCE_STATUS_COMPLIANT: '12B Compliant'
    };

    var userInfoPromise;

    function getPropData(data, name, content) {
      return InFlight.NLX.Utils.props(data, name)[content];
    }

    function getChildrenPropData(data, name, content) {
      if (data[name]) {
        try {
          var obj = data[name][0];
          return obj.Properties[content];
        } catch (e) {
          return null;
        }
      }
    }

    function trimString(str) {
      if (str) {
        return str.trim();
      }
      return str;
    }

    function doLogout() {
      var myconfig = {
        targetUrl: InFlight.NLX.Cfg.Customer.psLogoutBaseUrl(),
        targetVerb: 'GET',
        followProposedTemplate: false,
        manualRequestObj: [
          {
            Lbl: 'meta',
            Src: 'meta',
            Data: 'content url'
          },
          {
            Lbl: 'redirectForm',
            Src: 'form[name=myForm]',
            Data: 'action'
          },
          {
            Lbl: 'redirectWinLocation',
            Src: 'script:contains("window.location.replace")',
            Data: 'html'
          },
          {
            Lbl: 'imgLogout',
            Src: 'img[onload]',
            Data: 'src'
          }
        ],

        callback: function(data) {
          if(data.CaptureResults.redirectWinLocation) {
            var redirectHtml = data.CaptureResults.redirectWinLocation[0].Properties.html;
            var redirectRegex = /window\.location\.replace\(\s*['"]([^'"]*)/g
            var regexResult = redirectRegex.exec(redirectHtml);
            if (regexResult.length > 0) {
              InFlight.Utils.get(regexResult[1]).then(_doLogout, _doLogout);
            }
            return;
          }
          
          if (data.CaptureResults.meta) {
            var content = getPropData(data, 'meta', 'content');
            if (content) {
              var url = content.split('1; URL=')[1];
              if (url) {
                myconfig.targetUrl = url;
                InFlightDC.init(myconfig);
              } else {
                _doLogout();
              }
            }
            return;
          }

          if (data.CaptureResults.redirectForm) {
            var imgLogoutUrl = getPropData(data, 'imgLogout', 'src');
            InFlight.Utils.get(imgLogoutUrl).then(function() {
              var action = getPropData(data, 'redirectForm', 'action');
              if (action) {
                action = action.replace(':443', '');
              }
              if (action && action.indexOf('--IF') === -1) {
                action = InFlight.NLX.Cfg.Customer.psAuthBaseUrl() + action;
              }
              InFlight.Utils.get(action).then(_doLogout, _doLogout);
            });
          } else if(data && data.ProposedTemplate === '/signout.html'){
             _doLogout();
          }
        }
      };
      var InFlightDC = new InFlightDCType(false);
      InFlightDC.init(myconfig);
    }

    function isLoggedIn() {
      return !!currentUser() || _isLoggedInResultPage();
    }

    function _clearSession() {
      var clearsessionURL = '/inflight/clearsession';
      // IE11 has this cached so we bypass this via appending a variable to the end, which forces IE11 to do the call again
      // Probably not needed once IF7-440 is done
      if (navigator.userAgent.search("Trident") >= 0) {
        clearsessionURL += '?' + $.now();
      }
      return InFlight.Utils.get(clearsessionURL);
    }

    function _doLogout(cb) {
      _clearSession().then(function() {
        //TODO:  do logout server calls
        sessionStorage.clear();
        setPageHeader();

        if (cb) {
          cb();
        } else {
          InFlight.Utils.goTo('/pages/index.aspx');
        }
      });
    }

    function doLogin(clientParam) {
      var loginUrl = InFlight.NLX.Cfg.Customer.psLoginUrl();
      if (clientParam) {
        loginUrl = loginUrl.replace(
          '/IFRedirect/',
          '/IFRedirect/' + clientParam + '/'
        );
      }

      if (InFlight.NLX.Cfg.Customer.useDirectLogin) {
        InFlight.Utils.goTo(loginUrl);
        return;
      }
      // Hitting unauthenticated page first to retrieve necessary cookies
      var myconfig = {
        targetUrl: InFlight.NLX.Cfg.Customer.psRootUrl() + '/h/?tab=DEFAULT',
        targetVerb: 'GET',
        followProposedTemplate: false,
        callback: function(data) {
          if (data && data.CaptureResults) {
            InFlight.Utils.goTo(loginUrl);
          }
        }
      };
      var InFlightDC = new InFlightDCType(false);
      InFlightDC.init(myconfig);
    }

    function psBaseUrl() {
      return InFlight.User.isLoggedIn()
        ? InFlight.NLX.Cfg.Customer.psAuthBaseUrl()
        : InFlight.NLX.Cfg.Customer.psBaseUrl();
    }

    function psBaseUrl_newwin() {
      return InFlight.User.isLoggedIn()
        ? InFlight.NLX.Cfg.Customer.psAuthBaseUrl_newwin()
        : InFlight.NLX.Cfg.Customer.psBaseUrl_newwin();
    }

    function clearLogin(cb) {
      _clearSession().then(function() {
        sessionStorage.removeItem('User');
        setPageHeader();
        if (cb) {
          cb();
        }
      });
    }

    function _makeUserInfoRequest(callback) {
      var myconfig = {
        targetUrl:
          InFlight.NLX.Cfg.Customer.psAuthBaseUrl() +
          '/q/?ICAction=ICQryNameURL=PUBLIC.FSP_INFLIGHT_VENDOR_STATUS',
        targetVerb: 'GET',
        followProposedTemplate: false,
        manualRequestObj: [
          {
            Lbl: 'Company',
            Src: 'table.PSQRYTABLELEFTBORDER tr:not(:first)',
            Children: [
              {
                Lbl: 'AccountID',
                Src: 'td:eq(1)',
                Data: 'text'
              },
              {
                Lbl: 'EntityName',
                Src: 'td:eq(2)',
                Data: 'text'
              },
              {
                Lbl: 'EntityType',
                Src: 'td:eq(3)',
                Data: 'text'
              },
              {
                Lbl: 'ModifiedDate',
                Src: 'td:eq(4)',
                Data: 'text'
              },
              {
                Lbl: 'SupplierStatus',
                Src: 'td:eq(5)',
                Data: 'text'
              },
              {
                Lbl: 'GovClass',
                Src: 'td:eq(6)',
                Data: 'text'
              },
              {
                Lbl: 'TaxCertExpireDate',
                Src: 'td:eq(7)',
                Data: 'text'
              },
              {
                Lbl: 'ComplianceStatus',
                Src: 'td:eq(8)',
                Data: 'text'
              },
              {
                Lbl: 'UserName',
                Src: 'td:eq(9)',
                Data: 'text'
              }
            ]
          }
        ],
        callback: function(data) {
          if (data && data.CaptureResults && data.CaptureResults.Company) {
            var userData = [];
            var companies = data.CaptureResults.Company;
            var companyCount = companies.length;

            for (var i = 0; i < companyCount; i++) {
              var userCompanyInfo = getUserCompanyInfo(companies[i].Children);
              userData.push(userCompanyInfo);
            }

            sessionStorage.setItem('UserInfo', JSON.stringify(userData));
            if (callback) {
              callback(userData);
            }
          } else {
            sessionStorage.removeItem('UserInfo');
            if (callback) {
              callback(null);
            }
          }
        }
      };
      var InFlightDC = new InFlightDCType(false);
      InFlightDC.init(myconfig);
    }

    function extractUser(userInfo) {
      if (userInfo && userInfo.length === 1) {
        sessionStorage.User = userInfo[0].userName;
      } else {
        sessionStorage.removeItem('User');
      }
    }

    function getUserInfo() {

      return Promise.resolve([]);


      // debugger;
      // if (userInfoPromise) {
      //   return userInfoPromise;
      // } else {
      //   userInfoPromise = new Promise(function(resolve, reject) {
      //     var userInfo = sessionStorage.getItem('UserInfo');
      //     if (userInfo) {
      //       const userInfoObj = JSON.parse(userInfo)
      //       extractUser(userInfoObj);
      //       resolve(userInfoObj);
      //     } else {
      //       _makeUserInfoRequest(function(userInfo) {
      //         extractUser(userInfo);
      //         resolve(userInfo);
      //       });
      //     }
      //   });
      //   return userInfoPromise;
      // }
    }

    function getUserCompanyInfo(data) {
      var userInfo = {
        accountID: getChildrenPropData(data, 'AccountID', 'text'),
        company: getChildrenPropData(data, 'EntityName', 'text'),
        type: getChildrenPropData(data, 'EntityType', 'text'),
        modifiedDate: getChildrenPropData(data, 'ModifiedDate', 'text'),
        supplierStatus: trimString(
          getChildrenPropData(data, 'SupplierStatus', 'text')
        ),
        govClass: trimString(getChildrenPropData(data, 'GovClass', 'text')),
        taxExpirationDate: trimString(
          getChildrenPropData(data, 'TaxCertExpireDate', 'text')
        ),
        complianceStatus: trimString(
          getChildrenPropData(data, 'ComplianceStatus', 'text')
        ),
        userName: trimString(
          getChildrenPropData(data, 'UserName', 'text')
        ),
      };

      // create and check expiration status
      var today = Date.today();
      if (userInfo.type === _states.ENTITY_TYPE_SUPPLIER) {
        var expiration = Date.parse(userInfo.taxExpirationDate);
        userInfo.supplierExpirationStatus =
          _states.SUPPLIER_EXPIRATION_STATUS_INCOMPLETE;
        if (expiration) {
          userInfo.supplierExpirationStatus =
            _states.SUPPLIER_EXPIRATION_STATUS_GOOD;
          if (Date.compare(today, expiration) === 1) {
            userInfo.supplierExpirationStatus =
              _states.SUPPLIER_EXPIRATION_STATUS_EXPIRED;
          } else if (Date.compare(today.add({ months: 1 }), expiration) === 1) {
            userInfo.supplierExpirationStatus =
              _states.SUPPLIER_EXPIRATION_STATUS_IMMINENT;
          }
        }
      }

      // create account type
      userInfo.accountType = _states.ACCOUNT_TYPE_BIDDER; // by default users are bidders
      if (
        userInfo.supplierStatus === _states.SUPPLIER_STATE_UNAPPROVED &&
        userInfo.govClass === _states.GOV_CLASS_NONE &&
        userInfo.complianceStatus === _states.COMPLIANCE_STATUS_NONE
      ) {
        userInfo.accountType = _states.ACCOUNT_TYPE_SUBCONTRACTOR;
      } else if (
        userInfo.type === _states.ENTITY_TYPE_SUPPLIER &&
        (userInfo.govClass === _states.GOV_CLASS_DLQ ||
          userInfo.govClass === _states.GOV_CLASS_NONE) &&
        (userInfo.supplierExpirationStatus ===
          _states.SUPPLIER_EXPIRATION_STATUS_EXPIRED ||
          userInfo.complianceStatus === _states.COMPLIANCE_STATUS_PENDING ||
          userInfo.complianceStatus === _states.COMPLIANCE_STATUS_CONTRACT ||
          userInfo.complianceStatus === _states.COMPLIANCE_STATUS_DENIED)
      ) {
        userInfo.accountType = _states.ACCOUNT_TYPE_SUPPLIER_ISSUES;
      } else if (
        userInfo.supplierStatus === _states.SUPPLIER_STATE_APPROVED &&
        (userInfo.govClass === _states.GOV_CLASS_TAX ||
          userInfo.govClass === _states.GOV_CLASS_EX) &&
        userInfo.supplierExpirationStatus ===
          _states.SUPPLIER_EXPIRATION_STATUS_GOOD &&
        (userInfo.complianceStatus === _states.COMPLIANCE_STATUS_COMPLIANT ||
          userInfo.complianceStatus === _states.COMPLIANCE_STATUS_CONTRACT)
      ) {
        userInfo.accountType = _states.ACCOUNT_TYPE_APPROVED_SUPPLIER;
      } else if (
        userInfo.supplierStatus === _states.SUPPLIER_STATE_APPROVED &&
        userInfo.govClass === _states.GOV_CLASS_DND &&
        (userInfo.complianceStatus === _states.COMPLIANCE_STATUS_COMPLIANT ||
          userInfo.complianceStatus === _states.COMPLIANCE_STATUS_CONTRACT)
      ) {
        userInfo.accountType = _states.ACCOUNT_TYPE_APPROVED_SUPPLIER;
      } else if (
        userInfo.supplierStatus === _states.SUPPLIER_STATE_UNAPPROVED ||
        userInfo.type === _states.ENTITY_TYPE_SUPPLIER
      ) {
        userInfo.accountType = _states.ACCOUNT_TYPE_SUPPLIER_ISSUES;
      }

      return userInfo;
    }

    function currentUser() {
      return sessionStorage.User;
    }

    return {
      doLogin: doLogin,
      doLogout: doLogout,
      isLoggedIn: isLoggedIn,
      psBaseUrl: psBaseUrl,
      psBaseUrl_newwin: psBaseUrl_newwin,
      clearLogin: clearLogin,
      States: _states,
      getUserInfo: getUserInfo,
      currentUser: currentUser
    };
  })();

  $(function() {
    if (InFlight.User.isLoggedIn()) {
      if (_isLoggedInResultPage()) {
        // then just logged in
        InFlight.GTM.login();
      }
    } else {
      sessionStorage.removeItem('User');
      sessionStorage.removeItem('UserInfo');
    }
    setPageHeader();
  });
})();
